import ModalComponent from '@/components/modal/modal'

class Dialog {
  constructor ($vm) {
    this.$vm = $vm
    this.$content = this.$vm.$el.getElementsByClassName('dialog-main')[0]
    this._onConfirm = (e) => {
      if (typeof this.options.onConfirm === 'function') {
        if (this.options.onConfirm(e) === false) {
          return
        }
      }
      this.hide()
    }
    this._build()
    this._initEvent()
  }
  _build () {
    this.watcher && this.watcher()

    this.watcher = this.$vm.$watch('show', (val) => {
      if (val) {
        this.options.onShow()
      } else {
        this.options.onHide()
      }
    })
  }
  _initEvent () {
    this.$vm.$on('dismiss', (e) => {
      this.hide()
    })
    this.$vm.$on('onClick', (e) => {
      this._onConfirm(e)
    })
  }
  _extends (options) {
    for (let key in options) {
      if (key.substr(0, 2) === 'on' || key === 'show') {
        continue
      }
      this.$vm[key] = options[key]
    }
  }
  show (options, fn) {
    this.options = Object.assign({}, Dialog.defaults)
    if (typeof options === 'string') {
      this.options.content = options
      this.options.onConfirm = fn
    } else {
      Object.assign(this.options, options || {})
    }

    let selector, child
    if (typeof this.options.content === 'string') {
      this.options.simple = true
      selector = 'dialog-msg'
      child = document.createElement('div')
      child.innerHTML = this.options.content
    } else {
      this.options.simple = false
      selector = 'dialog-body'
      child = this.options.content
    }

    this._extends(this.options)

    this.$vm.$nextTick(() => {
      let el = this.$content.getElementsByClassName(selector)[0]
      el.innerHTML = ''
      el.appendChild(child)
    })

    this.$vm.show = true
    return this
  }
  hide () {
    this.$vm.show = false
    return this
  }
}

Dialog.defaults = {
  content: '',
  onShow () {},
  onHide () {}
}

export default (Vue) => {
  let Modal = Vue.extend(ModalComponent)
  let el = document.createElement('div')
  const $vm = new Modal()
  document.body.appendChild(el)
  $vm.$mount(el)

  const $dialog = new Dialog($vm)

  Vue.prototype.$dialog = (options, fn) => {
    return $dialog.show(options, fn)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/dialog.js